( function ( _s ) {
	/**
	 * Using the library serbanghita/form-to-object we create an object off the inputs of the form
	 * We also make it so that if any value on the object is an array we convert the values to comma
	 * separated values so that the URLs look shorter and the parameters on the AJAX calls are shorter
	 * to read too.
	 * @param _form
	 */
	const serializeFormData = _form => {
		const form = _form instanceof Element ? _form : _form.el[ 0 ];
		const data = window.formToObject( form, { includeEmptyValuedElements: true } );

		for ( const [ key, value ] of Object.entries( data ) ) {
			if ( Array.isArray( data[ key ] ) ) {
				data[ key ] = value.filter( n => n ).join( ',' ); //filter empty options just in case and comma separate
			}
		}
		return data;
	};

	const onFiltersChanged = ( _self, filterTarget = false ) => {
		_self.trigger( 'fr:filters-changed', {
			params: { ...serializeFormData( _self ), ...{ page: 1 } }, //change page number when filter changed,
			target: filterTarget,
		} );

		checkOrderByDropdown( _self, filterTarget );
	};

	const dropdownCurrentOptions = _dropdown => {
		const currentOptions = [];

		_dropdown.find( 'option' ).each( option => {
			currentOptions.push( {
				text: _s( option ).text(),
				value: _s( option ).attr( 'value' ),
			} );
		} );

		return currentOptions;
	};

	const addRelevanceFilterOption = ( _orderBy = false ) => {
		if ( _orderBy ) {
			const orderBySelect = _orderBy.firstElement();
			const _relevanceOption = _orderBy.find( '[value="relevance"]' );

			if ( ! _relevanceOption.length ) {
				const currentOptions = dropdownCurrentOptions( _orderBy );

				if ( orderBySelect.slim ) {
					orderBySelect.slim.setData( [
						...[ { text: 'Relevance', value: 'relevance' } ],
						...currentOptions,
					] );
					orderBySelect.slim.setSelected( 'relevance' );

					// Set data-default attribute to the relevance option
					_orderBy.find( `[value="relevance"]` ).attr( 'data-default', '' );
				}
			} else if ( ! _relevanceOption.filter( '[data-default]' ).length ) {
				_orderBy.find( '[data-default]' ).removeAttr( 'data-default' );
				_relevanceOption.attr( 'data-default', '' );
			}
		}
	};

	const removeRelevanceFilterOption = ( _orderBy = false ) => {
		if ( _orderBy ) {
			const orderBySelect = _orderBy.firstElement();

			if ( _orderBy.find( 'option[value="relevance"]' ).length ) {
				const defaultValue = _orderBy.attr( 'data-default-option' );
				const _default = _orderBy.find( `option[value="${ defaultValue }"]` );
				const currentOptions = dropdownCurrentOptions( _orderBy );

				if ( _default.length ) {
					if ( orderBySelect.slim ) {
						orderBySelect.slim.setData(
							currentOptions.filter( option => option.value !== 'relevance' )
						);
						orderBySelect.slim.setSelected( defaultValue, false );
					}
				}
			}
		}
	};

	/**
	 * When text search is made, update the "order by" dropdown so it includes the "relevance" option
	 * @param _self
	 * @param filterTarget
	 */
	const checkOrderByDropdown = ( _self, filterTarget ) => {
		if ( filterTarget && _s( filterTarget ).filter( '[name="search"], [name="s"]' ).length ) {
			const _orderBy = _self.find( '[name="order_by"]' );

			if ( _orderBy.length && filterTarget.value.length ) {
				addRelevanceFilterOption( _orderBy );
			} else {
				removeRelevanceFilterOption( _orderBy );
			}
		}
	};

	const removeDropdownFilter = ( filter, filterData ) => {
		if ( filter.hasAttribute( 'multiple' ) ) {
			const currentlySelected = filter.slim.getSelected();
			filter.slim.setSelected(
				currentlySelected.filter( selected => selected !== filterData.filterOptionValue ),
				false
			);
		} else {
			/** First option is selected */
			filter.slim.setSelected( [] );
		}

		const selectedOptions = filter.slim.getSelected();

		if (
			! selectedOptions ||
			( Array.isArray( selectedOptions ) && ! selectedOptions.length )
		) {
			_s( filter ).trigger( 'fr:dropdown-selection-cleared' );
		}
	};

	const removeInputFilter = filter => {
		switch ( filter.type ) {
			case 'checkbox':
				filter.checked = false;
				break;
			case 'text':
				filter.value = '';
				break;
		}
	};

	const removeFilter = ( _filters, filterData ) => {
		const _filter = _filters.find( `[name="${ filterData.filter }"]` );

		if ( _filter.length ) {
			/**
			 * If more than one element, then pick the one with the provided value
			 * Example: Multiple checkboxes can have the same name, in that case select the one whose value attribute matches filterData.filterOptionValue
			 */
			const filter =
				_filter.length > 1
					? _filter.filter( `[value="${ filterData.filterOptionValue }"]` ).firstElement()
					: _filter.firstElement();

			if ( ! filter ) return;

			switch ( filter.tagName.toLowerCase() ) {
				case 'select':
					removeDropdownFilter( filter, filterData );
					break;
				case 'input':
					removeInputFilter( filter );
					/** For input tags, trigger change event */
					_s( filter ).trigger( 'change' );
					break;
			}
		}
	};

	_s.fn.cardGridFilters = function () {
		return this.each( function ( el ) {
			const _self = _s( el );

			_self.find( 'input, select' ).on( 'change', e => {
				onFiltersChanged( _self, e.target );
			} );

			_self.on( 'submit', e => {
				if ( _self.closest( '.card-grid-with-filters-module' ).length && ! e.target.hasAttribute('data-allow-submit') ) {
					e.preventDefault();
					onFiltersChanged( _self );
				}
			} );

			_self.on( 'fr:remove-filter', e => {
				removeFilter( _self, e.detail );
			} );

			_self.find( '[name="search"], [name="s"]' ).each( field => {
				checkOrderByDropdown( _self, field );
			} );
		} );
	};

	_s( document ).ready( function () {
		_s( '.card-grid-filters' ).cardGridFilters();
	} );
} )( window._s );
